// 默认语言
import _ from 'lodash';
import { localeValueToKeyMap } from './multilingual-tools';
export default function get() {
  const localLanguage = localStorage.getItem('i18n');
  const browserLanguage = localeValueToKeyMap[navigator.language];
  const isBrowserLocale = _.isNil(browserLanguage)
    ? process.env.VUE_APP_LANGUAGE
    : browserLanguage;
  return _.isNil(localLanguage) ? isBrowserLocale : localLanguage;
}
